<template>
  <div
    class="product-empty"
    :class="{ 'product-empty--dark': $vuetify.theme.dark }"
    role="status"
  >
    <div class="product-empty__card">
      <div class="product-empty__art" aria-hidden="true">
        <span class="product-empty__art-line product-empty__art-line--top"></span>
        <span class="product-empty__art-line product-empty__art-line--bottom"></span>
        <span class="product-empty__art-icon">
          <v-icon size="32">fal fa-box-open</v-icon>
        </span>
        <span class="product-empty__art-plus">
          <v-icon size="14">fal fa-plus</v-icon>
        </span>
      </div>

      <div class="product-empty__text">
        <p class="product-empty__eyebrow">{{ $t("product_catalog") }}</p>
        <h2 class="product-empty__title">
          {{ $t("sale_empty_products_title") }}
        </h2>
        <p class="product-empty__hint">
          {{ $t("sale_empty_products_description") }}
        </p>
      </div>

      <v-btn
        depressed
        color="primary"
        class="product-empty__action"
        @click="$router.push({ name: 'manage_add_product' })"
      >
        <v-icon left small>fal fa-plus</v-icon>
        {{ $t("sale_empty_products_action") }}
      </v-btn>

      <p class="product-empty__note">
        <v-icon x-small>fal fa-lightbulb-on</v-icon>
        {{ $t("sale_empty_products_hint") }}
      </p>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
/* First-run catalog state for a newly created store. */
.product-empty {
  height: 100%;
  min-height: 500px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px 20px;
  text-align: center;
}

.product-empty__card {
  position: relative;
  width: min(100%, 760px);
  padding: 58px 72px 46px;
  overflow: hidden;
  border: 1px solid #e7e1f7;
  border-radius: 24px;
  background: linear-gradient(145deg, #ffffff 0%, #faf9ff 100%);
  box-shadow: 0 18px 42px rgba(52, 38, 105, 0.09);
}

.product-empty__card::after {
  position: absolute;
  top: -72px;
  right: -54px;
  width: 180px;
  height: 180px;
  border: 1px solid rgba(91, 57, 201, 0.1);
  border-radius: 50%;
  box-shadow: 0 0 0 20px rgba(91, 57, 201, 0.03),
    0 0 0 40px rgba(91, 57, 201, 0.025);
  content: "";
}

.product-empty__art {
  position: relative;
  width: 136px;
  height: 116px;
  margin: 0 auto 32px;
}

.product-empty__art-icon {
  position: absolute;
  z-index: 1;
  top: 10px;
  left: 16px;
  display: flex;
  width: 96px;
  height: 96px;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(91, 57, 201, 0.22);
  border-radius: 22px;
  background: #f1edff;
  color: #5b39c9;
  transform: rotate(-6deg);
}

.product-empty__art-plus {
  position: absolute;
  z-index: 2;
  right: 0;
  bottom: 0;
  display: flex;
  width: 36px;
  height: 36px;
  align-items: center;
  justify-content: center;
  border: 3px solid #fff;
  border-radius: 50%;
  background: #5b39c9;
  color: #fff;
}

.product-empty__art-plus .v-icon {
  color: #fff !important;
}

.product-empty__art-line {
  position: absolute;
  right: 0;
  width: 22px;
  height: 3px;
  border-radius: 99px;
  background: #d7cef7;
  transform: rotate(-6deg);
}

.product-empty__art-line--top {
  top: 20px;
}

.product-empty__art-line--bottom {
  top: 30px;
  right: 5px;
  width: 14px;
}

.product-empty__eyebrow {
  margin: 0 0 8px;
  color: #7d6db8;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.16em;
  text-transform: uppercase;
}

.product-empty__title {
  margin: 0;
  color: #252039;
  font-size: clamp(24px, 3vw, 32px);
  font-weight: 800;
  letter-spacing: -0.03em;
  line-height: 1.2;
}

.product-empty__hint {
  max-width: 500px;
  margin: 12px auto 0;
  color: #7b7790;
  font-size: 15px;
  line-height: 1.65;
}

.product-empty__action {
  min-width: 190px;
  margin-top: 26px;
  border-radius: 10px;
  font-weight: 700;
  letter-spacing: 0;
}

.product-empty__note {
  margin: 18px 0 0;
  color: #9a96a9;
  font-size: 11px;
}

.product-empty__note .v-icon {
  margin-right: 4px;
  color: #a28cdd;
}

.product-empty--dark .product-empty__card {
  border-color: #39334d;
  background: linear-gradient(145deg, #24202f 0%, #1e1b27 100%);
  box-shadow: 0 18px 42px rgba(0, 0, 0, 0.22);
}

.product-empty--dark .product-empty__art-icon {
  border-color: rgba(196, 181, 253, 0.26);
  background: #322954;
  color: #c4b5fd;
}

.product-empty--dark .product-empty__art-plus {
  border-color: #24202f;
}

.product-empty--dark .product-empty__title {
  color: #f5f3ff;
}

.product-empty--dark .product-empty__hint {
  color: #aaa4ba;
}

@media (max-width: 600px) {
  .product-empty {
    min-height: 360px;
    padding: 20px 12px;
  }

  .product-empty__card {
    padding: 34px 20px 26px;
    border-radius: 20px;
  }

  .product-empty__art {
    margin-bottom: 22px;
  }

  .product-empty__art-icon {
    width: 80px;
    height: 80px;
  }

  .product-empty__hint {
    font-size: 13px;
  }
}
</style>
